import { Grid } from '@material-ui/core'
import i18n from 'i18next'
import { FC } from 'react'
import { CustomList } from '../../../../components/Display/Lists'
import { MainOwner } from '../../../../types/apartments'
import { User } from '../../../../types/users'
import { getOwnerContactInfo } from '../../Forms/values/apartmentInitialValues'
import {
  businessClientInfoOrder,
  privateClientInfoOrder,
  noMainOwnerClientInfoOrder,
  realtorClientInfoOrder,
  businessRealtorClientInfoOrder
} from '../utils/dataHandling'

export interface MainOwnerListProps {
  mainOwner: MainOwner | undefined
  user: User
  t: i18n.TFunction
}

const getInfoOrder = (mainOwner: MainOwner | undefined) => {
  if (!mainOwner) {
    return noMainOwnerClientInfoOrder
  } else if (mainOwner?.role === 'roleRealtor' && mainOwner?.companyName) {
    //console.log('business client')
    return businessRealtorClientInfoOrder
  } else if (mainOwner?.role === 'roleRealtor') {
    return realtorClientInfoOrder
  } else {
    return mainOwner?.companyName
      ? businessClientInfoOrder
      : privateClientInfoOrder
  }
}

const MainOwnerList: FC<MainOwnerListProps> = ({ mainOwner, user, t }) => (
  <Grid item xs={12}>
    <CustomList
      t={t}
      translationPath='apartment.list.client.'
      data={getOwnerContactInfo(mainOwner, user)}
      informationOrder={getInfoOrder(mainOwner)}
      multiSelectPaths={{
        language: 'language'
      }}
    />
  </Grid>
)

export default MainOwnerList
